import request from '@/utils/request'

export default {
    getList(data) {
        return request({
          url: '/home/ovc/listPage',
          method:'post',
          data
        })
      },
      getdetail(id) {
        return request({
          url: `/home/ovc/homeDetail?id=${id}`,
          method:'get'
        })
      },
}